import { useQuery } from '@tanstack/react-query';
import PackagePose from '../models/PackagePose';

export default function usePackagePoses(packageId) {
  return useQuery({
    enabled: !!packageId,
    placeholderData: [],
    queryFn: () => (
      PackagePose
        .where({ packageId })
        .includes(['foreground', 'background'])
        .all()
        .then((res) => res.data)
    ),
    queryKey: ['PackagePoses', packageId],
  });
}
